import { Injectable } from '@angular/core';
import { FormsModels } from '../../../../models/forms.model';

const BONUS_BASE = 1.0;
const RATIO_PRIVATE = 0.95;
const RATIO_PRO = 0.93;
const VARIATION = 0.01;

export const MAX_YEARS_PRO = 9;
export const MAX_YEARS_PRIVATE = 13;

@Injectable({
  providedIn: 'root',
})
export class QuotationCoreService {
  private bonusList!: FormsModels.SelectListItem[];

  constructor() {
    this.generateBonusList();
  }

  public getBonusList(
    years: number,
    isPro: boolean,
  ): FormsModels.SelectListItem[] {
    const coef = this.getCoef(years, isPro);
    return this.bonusList.slice(50 - (BONUS_BASE - coef) * 100);
  }

  public getCoef(years: number, isPro: boolean): number {
    years = Math.min(isPro ? MAX_YEARS_PRO : MAX_YEARS_PRIVATE, years);
    const ratio = isPro ? RATIO_PRO : RATIO_PRIVATE;
    let coef = BONUS_BASE * 100;
    for (let i = 0; i < years; i++) {
      coef = Math.trunc(coef * ratio);
    }

    return Math.max(0.5, coef / 100);
  }

  private generateBonusList() {
    this.bonusList = [];
    let coef: number;
    for (let i = -50; i <= 250; i++) {
      coef = +(BONUS_BASE + VARIATION * i).toFixed(2);
      const bonusOrMalusWord = i <= 0 ? 'bonus' : 'malus';
      this.bonusList.push({
        value: coef,
        text: `${Math.abs(i).toFixed(0)} % ${bonusOrMalusWord} / coef ${coef}`,
      });
    }
  }
}
